import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';
import { TenantInfoObj } from '../../types/invoice';

@Injectable({
  providedIn: 'root'
})
export class InvoiceService {

  tenantSource: any = new BehaviorSubject(undefined);
  currentTenantData = this.tenantSource.asObservable();

  constructor(private httpClient: HttpClient) { }

  getTenant(lid: string, suite: string, account: string) {

    const path = `tenants/api/tenantInfo/${lid}/${suite}/${account}`;
    const url = environment.SITE_URL_LOCAL + path;

    const httpOptions = {
      withCredentials: true
    };

    return this.httpClient.get<TenantInfoObj>(url, httpOptions);

  }

  getTenantContacts(lid: string, suite: string, account: string) {

    const path = `tenants/api/tenantContacts/${lid}/${suite}/${account}`;
    const url = environment.SITE_URL_LOCAL + path;

    const httpOptions = {
      withCredentials: true
    };

    return this.httpClient.get<any>(url, httpOptions);

  }

  getWPSState(params: any) {
    let path = `mpid/api/aid/status/${params.facility}/${params.keycard}`;
    const url = environment.SITE_URL_LOCAL + path;

    const httpOptions = {
      withCredentials: true
    };

    return this.httpClient.get(url, httpOptions);

  }

  addWPSState(contact: any) {
    let path = `mpid/api/customer`;
    const url = environment.SITE_URL_LOCAL + path;

    const httpOptions = new HttpHeaders().set('Content-Type','application/x-www-form-urlencoded; charset=utf-8');

    return this.httpClient.post<any>(url, JSON.stringify(contact), {headers: httpOptions});

  }

  updateWPSState(params: any) {
    let path = `mpid/api/aid/status/${params.facility}/${params.keycard}`;
    const url = environment.SITE_URL_LOCAL + path;

    const httpOptions = new HttpHeaders().set('Content-Type','application/x-www-form-urlencoded; charset=utf-8');

    return this.httpClient.put<any>(url, JSON.stringify(params.body), {headers: httpOptions});

  }

  saveTenantContacts(params: any) {

    let path = `tenants/api/tenantContacts/${params.lid}/${params.suite}/${params.account}`;
    if(params['mode']) {
      path += '?mode='+params['mode'];
    }
    if(typeof params['contactPos'] !== undefined && params['contactPos'] >= 0) {
      path += '?contactPos='+params['contactPos'];
    }
    const url = environment.SITE_URL_LOCAL + path;

    const body = new HttpParams().set('payload', JSON.stringify(params.contacts))

    const httpOptions = new HttpHeaders().set('Content-Type','application/x-www-form-urlencoded; charset=utf-8');

    return this.httpClient.post<any>(url, body.toString(), {headers: httpOptions});

  }

  getInvoiceDetails(params: any): Observable<Object> {
    return this.httpClient.get(environment.BASE_URL_LOCAL + "monthlyInvoice/" + params.location + "/"+ params.suite +"/" + params.account);
  }
}
